import React from "react";
import { motion } from "framer-motion";
import { BookOpen, Camera } from "lucide-react";

const SecondaryHero = ({
  bgImgUrl,
  pageName,
  pageHead1,
  pageHead2,
  pageHead3,
  pageHead4,
  pageDesc,
}) => {
  return (
    <div>
      {/* Hero Section with Background Image */}
      <section className="relative min-h-[50vh] flex items-center justify-center overflow-hidden">
        {/* Background Image with Overlay */}
        <div className="absolute inset-0">
          <div
            className="w-full h-full bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: `url("${bgImgUrl}")`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          />
          <div className="absolute inset-0 bg-black/60"></div>
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/20 to-black/40"></div>
        </div>

        {/* Content */}
        <div className="relative container mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-4xl mx-auto"
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="inline-flex items-center px-6 py-2 rounded-2xl bg-white/10 backdrop-blur-sm border border-white/20 mb-8"
            >
              <div className="flex items-center space-x-2">
                <motion.div
                  animate={{ scale: [1, 1.2, 1] }}
                  transition={{ duration: 2, repeat: Infinity }}
                  className="w-2 h-2 bg-brandGreen rounded-full"
                />
                <BookOpen className="w-5 h-5 text-brandGreen" />
                <span className="text-lg font-normal">{pageName}</span>
              </div>
            </motion.div>

            {/* Main Heading */}
            <motion.h1
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.3 }}
              className="text-4xl lg:text-5xl xl:text-6xl font-bold mb-6 font-lexend"
            >
              {pageHead1} <span className="text-brandBlue">{pageHead2}</span>{" "}
              {pageHead3} <span className="text-brandGreen">{pageHead4}</span>
            </motion.h1>

            {/* Description */}
            <motion.p
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.5 }}
              className="text-lg lg:text-xl text-gray-200 leading-relaxed mb-8 max-w-3xl mx-auto"
            >
              {pageDesc}
            </motion.p>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default SecondaryHero;
